import type { ApiBead } from '@/lib/api';

interface BeadInfoProps {
  readonly bead: ApiBead;
  readonly onAdd: (bead: ApiBead) => void;
  readonly isInPalette: boolean;
}

export function BeadInfo({ bead, onAdd, isInPalette }: BeadInfoProps) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-3">
      {/* Color swatch */}
      <div
        className="h-10 w-10 shrink-0 rounded-md border border-gray-200"
        style={{ backgroundColor: bead.colorHex }}
      />

      {/* Details */}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-gray-900">{bead.code}</span>
          {bead.deltaE !== undefined && (
            <span className="rounded bg-gray-100 px-1.5 py-0.5 text-[10px] text-gray-500">
              ΔE {bead.deltaE}
            </span>
          )}
        </div>
        <p className="truncate text-xs text-gray-600">{bead.name}</p>
        <p className="text-[10px] text-gray-400">
          {bead.manufacturer.name} · {bead.finish} · {bead.colorHex}
        </p>
      </div>

      {/* Add button */}
      <button
        onClick={() => onAdd(bead)}
        disabled={isInPalette}
        className={`shrink-0 rounded-md px-3 py-1.5 text-xs font-medium ${
          isInPalette
            ? 'bg-gray-100 text-gray-400'
            : 'bg-primary-600 text-white hover:bg-primary-700'
        }`}
      >
        {isInPalette ? 'Dodany' : 'Dodaj'}
      </button>
    </div>
  );
}
